import React, { useCallback, useState } from "react";
import { ReactComponent as LoveIt } from "images/icons/love-it.svg"
import { ReactComponent as LoveItBreak } from "images/icons/love-it-break.svg"
import { classNames } from "src/common_util";

interface FavouriteButtonProps {
  isFavourite: boolean;
  onFavouriteChange: (isFavourite: boolean) => Promise<boolean>
}

const FavouriteButton = ({
  isFavourite,
  onFavouriteChange
}: FavouriteButtonProps
) => {
  const [isFavourited, setIsFavourited] = useState<boolean>(isFavourite);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isFirstHoverAfterEnable, setIsFirstHoverAfterEnable] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const onMouseEnter = () => setIsHovered(true);
  const onMouseLeave = () => {
    setIsHovered(false);
    setIsFirstHoverAfterEnable(false);
  }

  const submitFavouriteChange = useCallback((newIsFavourited: boolean) => {
    setIsSubmitting(true);
    onFavouriteChange(newIsFavourited)
      .then((favouriteResult) => { setIsFavourited(favouriteResult); }) // Sync button with actual response
      .catch(() => { setIsFavourited(!newIsFavourited) }) // Revert to original value
      .finally(() => setIsSubmitting(false));
  }, [onFavouriteChange]);

  const onClick = useCallback((e: React.MouseEvent<HTMLButtonElement>, newIsFavourited: boolean) => {
    e.preventDefault();
    setIsFavourited(newIsFavourited); // Provide immediate feedback
    setIsFirstHoverAfterEnable(true);

    submitFavouriteChange(newIsFavourited);
  }, [submitFavouriteChange]);

  const buttonClassNames = classNames({
    "button": true,
    "is-favourite": true,
    "favourite": isFavourited,
  })

  const notFavouritedButton = (
    <button className={buttonClassNames} onClick={e => onClick(e, true)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} disabled={isSubmitting} aria-label="favourite">
      <LoveIt className="icon streamline-icon" />
    </button>
  );

  const favouritedButton = (
    <button className={buttonClassNames} onClick={e => onClick(e, false)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} disabled={isSubmitting}>
      <div className={isHovered && !isFirstHoverAfterEnable && !isSubmitting ? "is-invisible" : ""}><LoveIt className="icon streamline-icon"/><span>Your favourite</span></div>
      <div className={isHovered && !isFirstHoverAfterEnable && !isSubmitting ? "" : "is-invisible"}><LoveItBreak className="icon streamline-icon"/><span>Unfavourite?</span></div>
    </button>
  );

  return (
    <div>
      {isFavourited ? favouritedButton : notFavouritedButton}
    </div>
  );
}

export default FavouriteButton;
